import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class OrganizationsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/organizations", { params: toSnakeCase(params) });
  }

  create(data) {
    return securedAxiosInstance.post("/organizations", toSnakeCase({ organization: data }));
  }

  update(id, data) {
    return securedAxiosInstance.put(`/organizations/${id}`, toSnakeCase({ organization: data }));
  }

  fetch(id, params) {
    return securedAxiosInstance.get(`/organizations/${id}`, { params: toSnakeCase(params) });
  }
}

export default new OrganizationsService();
